<template>
  <v-dialog
    persistent
    v-model="showNewDiagnosisDialog"
    max-width="1300"
    scrollable
    @keydown.esc="closeDialog()"
    overlay-opacity="0.9"
    :dark="compColor.isInDarkMode"
    :color="compColor.primeColor"
  >
    <div class="elevation-10 layout-column flex" style="border-radius: 6px;"
         v-bind:style="{background: compColor.contentFrame}">
      <ValidationObserver tag="div" ref="FormDetailForm" v-slot="{ pristine, valid }" class="layout-column flex">

        <!-- HEADER -->

        <div class="text-h6 font-weight-light pa-3 layout-row layout-align-center-center"
             :class="isDarkMode? 'blue-grey--text text--lighten-2' : ' grey--text text--darken-2'">
          <div class="flex"></div>
          <span>{{ $t('FORMS_DIVERSE.MODULE_DIAGNOSIS_DIALOG_HEADER') }}</span>

          <div class="flex"></div>
          <v-icon class="layout-align-end-end mr-1" @click="closeDialog()" :color="compColor.primeColor">cancel</v-icon>
        </div>

        <v-divider v-bind:style="{'border-color':compColor.lightDivider}"></v-divider>

        <!-- CONTENT  -->

        <div class="pa-4 layout-row layout-wrap" style="border-radius: 5px;overflow-y:auto;" :style="{'background': compColor.lxExpansion.background}">
          <diagnosis class="layout-row layout-wrap flex-gt-sm-100 flex-100"
                     path="diagnose"
                     :deathForm="deathForm"
                     :isNewDiagnosis="true"
                     :reportNewDiagnosis="reportNewDiagnosis"
                     @input-ignore="setReportValue"
                     v-model="model.diagnose"
                     :validationRef="$refs.FormDetailForm">
          </diagnosis>
        </div>

        <!-- ACTIONS -->

        <v-divider v-bind:style="{'border-color':compColor.lightDivider}"></v-divider>

        <div class="layout-row layout-align-end-center pt-1 pb-2 pr-1">
          <div class="layout-row">

            <!-- Save form (Reset)  -->

            <lx-btn classes="mr-1" :disabled="!valid || pristine"
                    width="auto"
                    :iconColor="'white'"
                    :color="compColor.primeColor"
                    @click="saveDiagnosis()"
                    icon="save" :tooltip="$t('buttons.save_form.tooltip')" :label="$t('buttons.save_form.value')"
                    :hide-label="false"></lx-btn>
          </div>
        </div>
      </ValidationObserver>
    </div>
  </v-dialog>
</template>

<script>
import diagnosis from '../../components/documentation/shared/Diagnose'
import lodash from 'lodash'
import utils from '../../common/utils'

export default {
  name: 'NewDiagnosisDialog',
  mixins: [utils],
  components: {
    diagnosis
  },
  props: {
    showNewDiagnosisDialog: Boolean,
    patientId: String,
    deathForm: Object
  },
  data: () => {
    return {
      formKey: 'register',
      model: {
        key: 'register',
        diagnose: {
          diagnosedatum_genauigkeit: 'E'
        }
      },
      oldModel: {
        key: 'register',
        diagnose: {
          diagnosedatum_genauigkeit: 'E'
        }
      },
      reportNewDiagnosis: false
    }
  },
  methods: {
    /**
     * Set reportNewDiagnosis-value after changing in diagnosis-module
     *
     * @param params {boolean} The changed value
     */
    setReportValue (params) {
      this.reportNewDiagnosis = params
    },

    /**
     * Close dialog
     */
    closeDialog () {
      this.clearForm()
      this.$emit('close-diagnosis-dialog')
    },

    /**
     * Reset validator, clear errorMsg and reset model
     */
    clearForm (reset) {
      if (reset) {
        reset()
      } else {
        this.$refs.FormDetailForm.reset()
      }
      this.model = lodash.cloneDeep(this.oldModel)
    },

    /**
     * Save new diagnosis
     */
    saveDiagnosis () {
      if (this.isLoading) {
        return
      }

      this.isLoading = true

      // create new diagnosis
      this.$http.put('/documentation/forms/register', this.model)
        .then(res => {
          if (res.data?.form?._id && !this.reportNewDiagnosis) {
            this.$http.patch('/documentation/formStatus/ignoredForReport/' + res.data.form._id)
              .then(() => {
                // trigger reloading of diagnosis list to actualize view of death form in list
                this.$eventBus.emit('reload-after-form-update-' + this.patientId)
                this.closeDialog()
              })
              .catch(this.NotifyError)
          } else {
            this.reportNewDiagnosis = false
            // trigger reloading of diagnosis list to actualize view of death form in list
            this.$eventBus.emit('reload-after-form-update-' + this.patientId)
            this.closeDialog()
          }
        })
        .catch((error) => {
          this.populateFormError(this.$refs.FormDetailForm, error)
            .catch(this.NotifyError)
            .finally(() => {
              this.serverErrorExists = true
              this.errorMsg = this.$t('ERROR_VALIDATION_WHILE_COMPLETING_FORM')
              this.isLoading = false
            })
        })
    },
  },
  watch: {
    showNewDiagnosisDialog: {
      handler: function (newValue, oldValue) {
        if (newValue && newValue !== oldValue) {
          this.errorMsg = null

          this.isLoading = true

          this.$http.get('/documentation/newForm/register')
            .then(res => {
              if (res.data) {
                res.data.form = res.data.form || {}
                res.data.form.key = 'register'
                res.data.form.diagnose = {
                  diagnosedatum_genauigkeit: 'E'
                }

                delete res.data.form._id

                res.data.form.patient_id = this.patientId
                this.model = res.data.form

                // set default values for new forms
                this.setDefaultValuesForNewForm()

                this.oldModel = lodash.cloneDeep(this.model)

                // reset field- and error-bag of validation to reset dirty-flags
                if (this.$refs.FormDetailForm) {
                  this.$refs.FormDetailForm.reset()
                }
              }
              this.isLoading = false
            })
            .catch(error => {
              this.isLoading = false
              this.NotifyError(error)
            })
        }
      }
    }
  }
}
</script>
